// Validación de identificadores fiscales españoles: DNI, NIE y CIF.
// No bloqueante: la calculadora muestra un aviso pero permite seguir.

const LETRAS_DNI = 'TRWAGMYFPDXBNJZSQVHLCKE';
const LETRA_CONTROL_CIF = 'JABCDEFGHI';

export function esNifValido(s: string | null | undefined): boolean {
  if (!s) return false;
  const t = s.trim().toUpperCase().replace(/\s|-/g, '');

  let m;

  // DNI: 8 dígitos + letra de control
  if ((m = t.match(/^(\d{8})([A-Z])$/))) {
    const num = parseInt(m[1], 10);
    return m[2] === LETRAS_DNI[num % 23];
  }

  // NIE: X/Y/Z + 7 dígitos + letra de control
  if ((m = t.match(/^([XYZ])(\d{7})([A-Z])$/))) {
    const prefix = m[1] === 'X' ? '0' : m[1] === 'Y' ? '1' : '2';
    const num = parseInt(prefix + m[2], 10);
    return m[3] === LETRAS_DNI[num % 23];
  }

  // CIF: letra (A-W salvo I,O) + 7 dígitos + dígito o letra de control
  if ((m = t.match(/^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/))) {
    const inicial = m[1];
    const cuerpo = m[2];
    const control = m[3];

    let sumaPar = 0;
    let sumaImpar = 0;
    for (let i = 0; i < 7; i++) {
      const d = parseInt(cuerpo[i], 10);
      if (i % 2 === 0) {
        // Posiciones impares (1ª, 3ª, ...): multiplicar por 2 y sumar dígitos.
        const x = d * 2;
        sumaImpar += Math.floor(x / 10) + (x % 10);
      } else {
        sumaPar += d;
      }
    }
    const total = (sumaPar + sumaImpar) % 10;
    const digitoControl = total === 0 ? 0 : 10 - total;
    const letraControl = LETRA_CONTROL_CIF[digitoControl];

    // Las organizaciones cuya inicial está en este conjunto exigen LETRA;
    // las que están en el conjunto numérico exigen DÍGITO; el resto admiten ambos.
    const exigeLetra = 'PQRSNW'.includes(inicial);
    const exigeDigito = 'ABEH'.includes(inicial);

    if (/^\d$/.test(control)) {
      if (exigeLetra) return false;
      return parseInt(control, 10) === digitoControl;
    } else {
      if (exigeDigito) return false;
      return control === letraControl;
    }
  }

  return false;
}
